import {request} from '@/utils/request'

var prg = process.env.PRG

export default {
  getDbItems () {
    return request({
      url: 'db-items?prg=' + prg + '&includeGroups=true',
      method: 'get'
    })
  },
  getAvailableLangs (dbId = null) {
    return request({
      url: '/base/langs' + (dbId != null ? '?dbId=' + dbId : ''),
      method: 'get'
    })
  },
  getTranslations (dbId) {
    return request({
      url: '/base/translations' + (dbId != null ? '?dbId=' + dbId : ''),
      method: 'get'
    })
  },
  login (dbId, username, password, rememberme) {
    return request({
      url: 'login/' + dbId + (rememberme ? '?rememberme=true' : ''),
      method: 'post',
      headers: {
        'X-Auth-Username': username,
        'X-Auth-Password': password
      }
    })
  },
  logout () {
    return request({
      // url: '/login?logout',
      url: '/logout',
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/rest/login.js